import { InfoCard, MarkdownContent } from '@backstage/core-components';

// Edit the text here; links to pages inside Launchpad use plain paths.
const welcomeMarkdown = `
Launchpad is Essity's developer portal. Find software, create new components from templates and read documentation in one place.

- **Explore the catalog**: find components, APIs and their owners in the [Software Catalog](/catalog).
- **Create a component**: start from a standard template in [Create](/create).
- **Read the docs**: open technical documentation in [Docs](/docs).
`;

export const WelcomeCard = () => (
  <InfoCard title="Welcome to Launchpad">
    <MarkdownContent content={welcomeMarkdown} />
  </InfoCard>
);
